import React, { memo } from 'react';
import { SxProps, Theme } from '@mui/material';
import { Modal } from 'components/Modal/Modal';
import { ArticleContent } from './ArticleContent/ArticelContent';

export interface ArticleViewProps {
  url: string;
  title: string;
  open: boolean;
  onClose: () => void;
  /** Render the modal header. Defaults to Modal's own behavior when omitted. */
  showHeader?: boolean;
  /** Show the favorite star in the header. Optional — omit for checklist articles. */
  showFavorite?: boolean;
  /** Current favorite state. */
  isFavorited?: boolean;
  /** Called with the next favorite state when the star is tapped. */
  onToggleFavorite?: (nextIsFavorited: boolean) => void;
  /** Force the close (X) button visibility, bypassing device-type default. */
  overrideCloseButtonVisible?: boolean;
  /** Force the back arrow visibility, bypassing device-type default. */
  overrideBackButtonVisible?: boolean;
  /** Called when the back arrow is tapped. */
  onClickBack?: () => void;
  /** Custom styles for the modal dialog. */
  modalStyles?: SxProps<Theme>;
}

export const ArticleView = memo(
  ({
    url,
    title,
    open,
    onClose,
    showHeader,
    showFavorite = false,
    isFavorited = false,
    onToggleFavorite,
    overrideCloseButtonVisible,
    overrideBackButtonVisible = false,
    onClickBack,
    modalStyles,
  }: ArticleViewProps) => (
    <Modal
      onClose={onClose}
      open={open}
      className="article-modal"
      modalTitleId="article-view__article-title"
      modalTitle={title}
      overrideBackButtonVisible={overrideBackButtonVisible}
      showHeader={showHeader}
      showFavorite={showFavorite}
      isFavorited={isFavorited}
      onToggleFavorite={onToggleFavorite}
      overrideCloseButtonVisible={overrideCloseButtonVisible}
      onClickBack={onClickBack}
      modalStyles={{
        width: '100%',
        height: '100%',
        backgroundColor: 'grey.300',
      }}
    >
      <ArticleContent url={url} />
    </Modal>
  ),
);

ArticleView.displayName = 'ArticleView';
